// Back to top button

// Extend jQuery to include a custom easing function
$.extend($.easing, {
  easeInOutQuad: function (x, t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  },
});

$(document).ready(function () {
  var btnContainer = $("#backToTop");
  var btn = $("#backToTop .btn-top");
  var scrollTimeout; // Timeout variable for throttling

  $(window).on("scroll", function () {
    clearTimeout(scrollTimeout); // Clear the timeout on each scroll event
    scrollTimeout = setTimeout(function () {
      if ($(window).scrollTop() > 200) {
        btnContainer.fadeIn(200);
      } else {
        btnContainer.fadeOut(200);
      }
    }, 100); // Delay of 100 milliseconds for throttling
  });

  btn.on("click", function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      700,
      "easeInOutQuad",
    ); // Use the custom easing function
  });
});
